import config from "../config/config";
import axios from "axios";
import { getToken } from "../Token";
import * as url from "../helpers/url_helper";
import { getTimezoneInfo } from '../helpers/timezone_helper';

const { timezoneName, formattedOffset } = getTimezoneInfo();
const token = getToken();

const getAxiosConfig = (endpoint, data) => ({
    method: 'post',
    url: `${config.API_URL}${endpoint}`,
    headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        "Timezone-Name": timezoneName,
        "Timezone-Offset": formattedOffset,
    },
    data
});

export const VendorAccountingApi = {
    createVendorAccounting: async (data) => {
        return await axios(getAxiosConfig(url.CREATE_VENDOR_ACCOUNTING, data));
    },

    updateVendorAccounting: async (data) => {
        return await axios(getAxiosConfig(url.UPDATE_VENDOR_ACCOUNTING, data));
    },

    deleteVendorAccounting: async (data) => {
        return await axios(getAxiosConfig(url.DELETE_VENDOR_ACCOUNTING, data));
    },

    getVendorAccounting: async (data) => {
        return await axios(getAxiosConfig(url.GET_VENDOR_ACCOUNTING, data));
    },

    getVendorAccountingSummary: async (data) => {
        return await axios(getAxiosConfig(url.GET_VENDOR_ACCOUNTING_SUMMARY, data));
    },

    settleVendorAccounting: async (data) => {
        return await axios(getAxiosConfig(url.SETTLE_VENDOR_ACCOUNTING, data));
    },

    settleAllVendorAccounting: async (data) => {
        return await axios(getAxiosConfig(url.SETTLE_ALL_VENDOR_ACCOUNTING, data));
    },

    getVendorAccountingById: async (data) => {
        return await axios(getAxiosConfig(url.GET_VENDOR_ACCOUNTING_BY_ID, data));
    },

    getVendors: async (data) => {
        return await axios(getAxiosConfig(url.GET_USERS_BY_ROLE, {
            ...data,
            role_id: 2 // for vendor (salon Admin)
        }));
    }
};
